let detailList = [
  {h1: '付帅'},
  {h2: '',h4: []},
  {h2: '硬件产品',h4: ['云播报','云打印','其他设备']},
  {h2: '服务',h3: '020-28185798',h5: '7*24小时全年无休'}
]

export default detailList



// WEBPACK FOOTER //
// ./src/assets/conf/footer.js